// extracted by mini-css-extract-plugin
export default {"desktop":"_2J20s","compact":"_1sgBK","mobile":"_1HOXM"};